import React from "react";
import styles from "./PrivacyPolicyPage.module.scss";

import Footer from '../../components/Footer/Footer';

const PrivacyPolicyPage_Es = () => {
  return (
    <>
        <div className={styles.container}>
            <div className={styles.content}>
                <h1>Política de privacidad</h1>
                <hr />
                <p>
                    Damos gran importancia a la protección de sus datos personales. 
                    Esta política de privacidad explica cómo recopilamos, usamos y protegemos su información.
                </p>

                <h2>1. Datos recopilados</h2>
                <p>Recopilamos los siguientes datos:</p>
                <ul>
                    <li>Nombre de usuario (que puede ser mostrado a otros usuarios en la clasificación general del juego)</li>
                    <li>Dirección de correo electrónico</li>
                    <li>Código postal (utilizado únicamente con fines estadísticos)</li>
                </ul>

                <h2>2. Base legal para el tratamiento</h2>
                <p>
                    El tratamiento de sus datos personales se basa en los siguientes fundamentos legales:
                </p>
                <ul>
                    <li>Ejecución del contrato cuando utiliza nuestro servicio.</li>
                    <li>Interés legítimo para mostrar la clasificación general de los jugadores.</li>
                </ul>

                <h2>3. Período de retención de datos</h2>
                <p>
                    Sus datos personales se conservan por un período de <strong>3 años</strong>&nbsp;
                    después de su última actividad en nuestro servicio. <br/>Después de este período, serán eliminados.
                </p>

                <h2>4. Uso de los datos</h2>
                <p>Usamos sus datos únicamente para:</p>
                <ul>
                    <li>Asegurar el correcto funcionamiento del servicio</li>
                    <li>Permitirle iniciar sesión</li>
                    <li>Compilar estadísticas del juego y una clasificación general de jugadores (solo se muestra el nombre de usuario)</li>
                    <li>Analizar la distribución geográfica de los jugadores (a través del código postal, de forma anónima)</li>
                </ul>

                <h2>5. Protección de sus datos</h2>
                <p>
                    Implementamos medidas técnicas y organizativas adecuadas para 
                    proteger su información contra accesos no autorizados, alteraciones, divulgaciones o destrucciones.
                    Estas medidas incluyen el cifrado de datos y controles de acceso estrictos.
                </p>

                <h2>6. Sus derechos</h2>
                <p>
                    De acuerdo con el RGPD, usted tiene los siguientes derechos:
                </p>
                <ul>
                    <li>Derecho de acceso: Puede obtener una copia de sus datos.</li>
                    <li>Derecho de rectificación: Puede corregir su información.</li>
                    <li>Derecho de eliminación: Puede solicitar la eliminación de sus datos.</li>
                    <li>Derecho a la portabilidad de los datos: Puede recibir sus datos en un formato estructurado.</li>
                    <li>Derecho a la limitación del tratamiento: Bajo ciertas condiciones, puede solicitar restringir el uso de sus datos.</li>
                </ul>
                <p>
                    Para ejercer estos derechos, contáctenos en la siguiente dirección:&nbsp;
                    <a className={styles.link} href="mailto:contact@hatanna-editions.fr">contact@hatanna-editions.fr</a>.
                </p>

                <h2>7. Reclamación ante la CNIL</h2>
                <p>
                    Si considera que sus derechos no están siendo respetados, puede presentar una reclamación 
                    ante la CNIL (Comisión Nacional de Informática y Libertades) en su sitio web oficial:
                    <a className={styles.link} href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer"> www.cnil.fr</a>.
                </p>

                <h2>8. Transferencia de datos fuera de la UE</h2>
                <p>
                    Sus datos se almacenan dentro de la Unión Europea. No se realiza ninguna transferencia fuera de la UE. Sus datos no se comparten con terceros.
                </p>
            </div>
        </div>

        <Footer/>
    </>
  );
};

export default PrivacyPolicyPage_Es;
